import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Row, Table } from '@themesberg/react-bootstrap'
import React from 'react'
import PaymentProvidersList from '../../../../components/PaymentProvidersList'
import Preloader from '../../../../components/Preloader'
import { toast } from '../../../../components/Toast'
import useDeposit from '../hooks/useDeposit'

const Deposit = ({
  createTenantData,
  setCreateTenantData,
  setSelectedTab,
  selectedTab,
  depositMethods
}) => {
  const {
    loading,
    data
  } = useDeposit(selectedTab)

  return (
    <>
      {
        loading
          ? <Preloader />
          : (
            <>
              <Row>
                <Col>
                  <PaymentProvidersList
                    data={data}
                    createTenantData={createTenantData}
                    setCreateTenantData={setCreateTenantData}
                    selectedTab={selectedTab}
                    tenant
                  />
                </Col>
                <Col>
                  <Table
                    
                    striped
                    responsive
                    hover
                    size='sm'
                    className='text-center'
                  >
                    <thead className='thead-light'>
                      <tr>
                        <th>Provider</th>
                        {depositMethods?.length && <th>Apply To All Bonuses</th>}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {typeof (createTenantData.depositMethods) === 'object' && !!createTenantData.depositMethods.length && createTenantData.depositMethods.map(({ name, paymentProviderId }) => {
                        return (
                          <tr key={name}>
                            <td>{name}</td>
                            {depositMethods?.length &&
                              <td>
                                <input
                                  name={name} type='checkbox'
                                  disabled={depositMethods?.includes(paymentProviderId)}
                                  defaultChecked={createTenantData?.depositMethods?.filter(item => item.paymentProviderId === paymentProviderId && item.applyToBonus)?.length}
                                  onClick={(e) => {
                                    setCreateTenantData({
                                      ...createTenantData,
                                      depositMethods: createTenantData.depositMethods.reduce((methods, currentItem) => {
                                        if (currentItem?.paymentProviderId === paymentProviderId) {
                                          methods.push({
                                            ...currentItem,
                                            applyToBonus: !!e.target.checked
                                          })
                                        } else {
                                          methods.push(currentItem)
                                        }
                                        return methods
                                      }, [])
                                    })
                                  }}
                                />
                              </td>}
                            <td>
                              <Button
                                variant='danger'
                                size='sm'
                                onClick={() => {
                                  setCreateTenantData({
                                    ...createTenantData,
                                    depositMethods: createTenantData.depositMethods.filter(item => item.paymentProviderId !== paymentProviderId)
                                  })
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                      {(!createTenantData || !createTenantData.depositMethods || createTenantData.depositMethods.length === 0) &&
                        (
                          <tr>
                            <td
                              colSpan={2}
                              className='text-danger text-center'
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <div className='d-flex justify-content-between mt-3'>
                <Button
                  onClick={() => setSelectedTab('credentials')}
                  variant='outline-warning'
                >
                  Previous
                </Button>

                <Button
                  onClick={() => {
                    if (createTenantData.depositMethods.length) {
                      setSelectedTab('withdraw')
                    } else {
                      toast('Please Add at least one Deposit Method', 'error')
                    }
                  }}
                  variant='outline-success'
                >
                  Next
                </Button>
              </div>
            </>
            )

}
    </>
  )
}

export default Deposit
